import Vue from 'vue'
import VueSee from '@xunlei/vue-see'

Vue.use(VueSee)
